<template>
  <input
    :placeholder="placeholder"
    autocomplete="tel-national"
    @input="phoneInput($event)"
    v-imask="{mask: '{+7} 000 000-00-00'}"
    type="text"
  />
</template>
<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: ["placeholderPhone"],
  data() {
    return {
      placeholder: this.placeholderPhone
        ? this.placeholderPhone
        : "+7 987 654-32-11"
    };
  },
  methods: {
    phoneInput(event: Event) {
      const target = event.target as HTMLInputElement;
      let number = target.value.replace(/[^+\d]/g, "");
      if (number.slice(0, 2) != "+7") {
        if (Number(number) == 8) {
          number = "+7";
        } else {
          number = "+7" + number;
        }
      }
      const formattedNumber = number.slice(0, 12);
      target.value = formattedNumber;
      this.$emit("update:modelValue", formattedNumber);
    }
  }
});
</script>
